import React from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';

import { useAuth } from '../../../../../../hooks/Auth';
import { FiSend } from 'react-icons/fi';
import Whatsapp from '../../../../../../components/Whatsapp';
import { authTitle } from '../../../../../../config';
import { FaChartBar, FaFilePdf, FaInfoCircle, FaMoneyBill, FaMoneyBillAlt, FaPiggyBank } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import downloadit from '../../../../../../utils/download';
import { string } from 'yup';
import handleFinanceReportPDF from './handleFinanceReportPDF';
import { AiFillBank } from 'react-icons/ai';
import { formatReal } from 'src/utils/format';
import { useModal } from 'src/hooks/Modal';

interface ICreateModule {
  lineData: Record<string, any>;
}

export const FinanceReportByProjectModule: React.FC<ICreateModule> = ({ lineData }) => {

  const { user } = useAuth();
  const { addToast } = useToast();
const {addModal} = useModal();
  const callTransfer = async (url) => {
    try {
      await api.get(url)
      addToast({ title: 'Saque realizado com sucesso', type: 'success' })

    }
    catch (err) {
      addToast({ title: 'Erro ao sacar', type: 'error' })
    }
  }

  const generateTransfer = async (saldo) => {
try{
 await api.post(`/make-marketplace-direct-transfer/${lineData?._id}`, { saldo: saldo});

 addToast({title:'Saque realizado com sucesso', type:'success'})

}
catch(err){

  addToast({title:'Erro ao realizar saque', type:'error'})

}

  }

const prepareReport = async () => {

 const response = await api.get(`/check-saldo-static/${lineData.url}/json`);

const saldo = response?.data?.rows?.length <= 0 ? 0 : response?.data?.rows?.[response?.data?.rows?.length -1]?.saldo;

    addModal({
            theme: 'whiteModalMini',
            title: '', content: saldo > 0 ? <>
                <p style={{ fontSize: '14px', padding: '10px', color: '#333', textAlign: 'center' }}>Saldo: {formatReal(saldo)}</p>
                <button className='defaultButton' onClick={() => generateTransfer(saldo)}>Sacar</button>


            </> : <p>Saldo negativo {saldo}</p>
        })

}



  const gerarRelatorioFinanceiro = async (operation) => {

    addToast({ title: 'Gerando relatório', type: 'info' });

    await downloadit({ url: `/check-saldo-static/${lineData.url}/${operation}` });


  }

  const gerarRelatorioFinanceiroPDF = async (operation) => {

    addToast({ title: 'Gerando relatório', type: 'info' });

    const project = await api.get(`/projects/${lineData._id}`)

    const response = await api.get(`/check-saldo-static/${lineData.url}/json`);

    handleFinanceReportPDF({ data: response?.data, project: project?.data })


  }

  const gerarRelatorioFinanceiroPDFForceNew = async (operation) => {

    addToast({ title: 'Gerando relatório', type: 'info' });

    const project = await api.get(`/projects/${lineData._id}`)

    const response = await api.post(`/check-saldo-static/${lineData.url}/json`, { paymentReferenceId: 're_clx4o8ucu4i59019tm6m48shr' });

    handleFinanceReportPDF({ data: response?.data, project: project?.data })


  }

  const gerarRelatorioFinanceiroComRecebiveis = async () => {

    addToast({ title: 'Gerando relatório com recebíveis', type: 'info' });

    await downloadit({ url: `/check-saldo-static-com-recebiveis/${lineData.url}` });


  }

    const gerarRelatorioFinanceiroPDFAntigo = async (operation) => {

    addToast({ title: 'Gerando relatório', type: 'info' });

    const project = await api.get(`/projects/${lineData._id}`)

    const response = await api.get(`/check-saldo/${lineData.url}/json`);

    handleFinanceReportPDF({ data: response?.data, project: project?.data })


  }

  const moduleUpdate: React.FC<ICreateModule> = ({ lineData }): JSX.Element => (
    <><button title="Relatório Financeiro" className="lineIcon" type="button" onClick={() => gerarRelatorioFinanceiro('')}>
      <FaMoneyBill />
    </button>
      <button title="Listar Saques" className="lineIcon" type="button" onClick={() => gerarRelatorioFinanceiro('saque')}>
        <FaMoneyBillAlt />
      </button>
      <button title="Lista de recebíveis" className="lineIcon" type="button" onClick={() => gerarRelatorioFinanceiroComRecebiveis()}>
        <FaChartBar />
      </button>
      <button title="Relatório Financeiro em PDF com resumo" className="lineIcon" type="button" onClick={() => gerarRelatorioFinanceiroPDF('')}>
        <FaFilePdf />
      </button>

      <button title="Verificar pagamentos na conta nova" className="lineIcon" type="button" onClick={() => gerarRelatorioFinanceiroPDFForceNew('')}>
        <FaInfoCircle />
      </button>

 {lineData?.new_finance !== 'yes' ? <button title="Relatório Financeiro de contas antigas" className="lineIcon" type="button" onClick={() => gerarRelatorioFinanceiroPDFAntigo('')}>
      <FaFilePdf color='purple' />
    </button> : <></>}
      
      {user?.email === 'guilherme@encontrodigital.com.br' && lineData?.new_finance === 'yes' ? <button title="Realizar Saque" onClick={() =>  prepareReport()} className="lineIcon" type="button"  >
        <AiFillBank color='orange' /> </button> : <></>}

    </>
  );

  return moduleUpdate({ lineData });
}
